export interface SurveySchema {
  id: SurveyType
  content: string
  answers?: string
}

export enum SurveyType {
  MidYear = 1,
}
